export class ARConstants {
    static readonly ADJUSTMENT_TYPE_CREDIT = 'credit';
    static readonly ADJUSTMENT_TYPE_DEBIT = 'debit';
    static readonly CREDIT_CODE = 'CR';
    static readonly DEBIT_CODE = 'DR';
}
